/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Announcement } from '../models/announcement';
import { deleteServiceProviderAnnouncement } from '../fn/service-provider/delete-service-provider-announcement';
import { DeleteServiceProviderAnnouncement$Params } from '../fn/service-provider/delete-service-provider-announcement';
import { deleteServiceProviderOrganizations } from '../fn/service-provider/delete-service-provider-organizations';
import { DeleteServiceProviderOrganizations$Params } from '../fn/service-provider/delete-service-provider-organizations';
import { getServiceProviderAnnouncement } from '../fn/service-provider/get-service-provider-announcement';
import { GetServiceProviderAnnouncement$Params } from '../fn/service-provider/get-service-provider-announcement';
import { patchServiceProviderAnnouncement } from '../fn/service-provider/patch-service-provider-announcement';
import { PatchServiceProviderAnnouncement$Params } from '../fn/service-provider/patch-service-provider-announcement';
import { postServiceProviderAnnouncement } from '../fn/service-provider/post-service-provider-announcement';
import { PostServiceProviderAnnouncement$Params } from '../fn/service-provider/post-service-provider-announcement';


/**
 * Service provider operations including announcement management and organization administration
 */
@Injectable({ providedIn: 'root' })
export class ServiceProviderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteServiceProviderOrganizations()` */
  static readonly DeleteServiceProviderOrganizationsPath = '/service-provider/organizations/{organizationKey}';

  /**
   * delete an organization.
   *
   * Delete an organization. The organization is first deactivated and
   * after 10 weeks deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteServiceProviderOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderOrganizations$Response(params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteServiceProviderOrganizations(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * delete an organization.
   *
   * Delete an organization. The organization is first deactivated and
   * after 10 weeks deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteServiceProviderOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderOrganizations(params: DeleteServiceProviderOrganizations$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteServiceProviderOrganizations$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postServiceProviderAnnouncement()` */
  static readonly PostServiceProviderAnnouncementPath = '/service-provider/announcements';

  /**
   * Create a global announcement.
   *
   * Create a new global announcement visible to all users.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postServiceProviderAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderAnnouncement$Response(params: PostServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    const obs = postServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a global announcement.
   *
   * Create a new global announcement visible to all users.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postServiceProviderAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postServiceProviderAnnouncement(params: PostServiceProviderAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    const resp = this.postServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

  /** Path part for operation `getServiceProviderAnnouncement()` */
  static readonly GetServiceProviderAnnouncementPath = '/service-provider/announcements/{announcementKey}';

  /**
   * Get an announcement by key.
   *
   * Retrieve a specific global announcement by its key.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceProviderAnnouncement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderAnnouncement$Response(params: GetServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    const obs = getServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an announcement by key.
   *
   * Retrieve a specific global announcement by its key.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceProviderAnnouncement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceProviderAnnouncement(params: GetServiceProviderAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    const resp = this.getServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

  /** Path part for operation `deleteServiceProviderAnnouncement()` */
  static readonly DeleteServiceProviderAnnouncementPath = '/service-provider/announcements/{announcementKey}';

  /**
   * Delete an announcement.
   *
   * Delete a global announcement.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteServiceProviderAnnouncement()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderAnnouncement$Response(params: DeleteServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete an announcement.
   *
   * Delete a global announcement.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteServiceProviderAnnouncement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteServiceProviderAnnouncement(params: DeleteServiceProviderAnnouncement$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchServiceProviderAnnouncement()` */
  static readonly PatchServiceProviderAnnouncementPath = '/service-provider/announcements/{announcementKey}';

  /**
   * Update an announcement.
   *
   * Update a global announcement with partial data.
   * This endpoint can only be used by service providers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchServiceProviderAnnouncement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchServiceProviderAnnouncement$Response(params: PatchServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
    const obs = patchServiceProviderAnnouncement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an announcement.
   *
   * Update a global announcement with partial data.
   * This endpoint can only be used by service providers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchServiceProviderAnnouncement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchServiceProviderAnnouncement(params: PatchServiceProviderAnnouncement$Params, context?: HttpContext): Observable<Announcement> {
    const resp = this.patchServiceProviderAnnouncement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Announcement>): Announcement => r.body)
    );
  }

}
